import React from 'react';
import { Link } from 'react-router-dom';

/**
 * EmptyState -- shared "nothing here yet" placeholder for list pages.
 *
 * Props:
 *   icon      optional emoji / unicode glyph
 *   title     short headline
 *   body      one-liner explaining what populates this list
 *   ctaLabel  optional primary action label
 *   ctaTo     optional react-router link target for the primary action
 *   ctaHref   optional external link for the primary action
 *   onCta     optional click handler (used when ctaTo/ctaHref are absent)
 */
export default function EmptyState({
  icon = 'i',
  title,
  body,
  ctaLabel,
  ctaTo,
  ctaHref,
  onCta,
}) {
  const cta = ctaLabel ? (
    ctaTo ? (
      <Link to={ctaTo} className="dm-empty__cta">{ctaLabel}</Link>
    ) : ctaHref ? (
      <a href={ctaHref} className="dm-empty__cta">{ctaLabel}</a>
    ) : (
      <button type="button" className="dm-empty__cta" onClick={onCta}>
        {ctaLabel}
      </button>
    )
  ) : null;

  return (
    <div className="dm-empty" role="status">
      <div className="dm-empty__icon" aria-hidden="true">{icon}</div>
      {title && <div className="dm-empty__title">{title}</div>}
      {body && <div className="dm-empty__body">{body}</div>}
      {cta}
    </div>
  );
}
